import PropTypes from 'prop-types'
import React from 'react'
import Button from 'components/Button'
import Input from 'components/Form/Input'
import classes from './NewOption.scss'

import { guid } from 'helpers/index'

export const submitInputId = `submit-${guid()}`

export const NewOption = (props) => (
  <form onSubmit={props.handleSubmit} className={classes['form']}>
    <input type='submit' id={submitInputId} className={classes.hidden} />

    <header className={classes['header']}>
      <div className={classes['header-title']}>
        Adding a New Spec
      </div>
    </header>

    <fieldset>
      <Input label='Name' placeholder='name' {...props.fields.name} />
    </fieldset>

    <footer className={classes['footer']}>
      <Button element={'label'} htmlFor={submitInputId} stick options={['green', 'block']}>
        Create Spec
      </Button>
    </footer>
  </form>
)

NewOption.propTypes = {
  option: PropTypes.object.isRequired,
  onSubmit: PropTypes.func, // actual submit function
  handleSubmit: PropTypes.func.isRequired, // redux-form function
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired
}

export default NewOption



// WEBPACK FOOTER //
// ./src/components/Options/New/NewOption.js